import {CtImage} from './ct-image';
import {construct, createInstance, ModelProperties} from '../utils';

export class CtImageSource {
    id!: number;

    width!: number;

    height!: number;

    src!: string;

    density!: number;

    mimetype!: string;

    blank!: boolean;

    placeholder!: boolean;

    breakpoint?: string | null;

    imageId!: number;

    image?: CtImage;

    constructor(source?: ModelProperties<CtImageSource>) {
        if (source) {
            construct(this, source);
            this.image = createInstance(CtImage, source.image);
        }
    }
}